import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'mat-icon',
  standalone: true,
  templateUrl: './mat-icon.component.html',
  styleUrl: './mat-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatIconComponent implements OnChanges {
  @Input() icon = '';
  @Input('aria-hidden') ariaHidden = 'true';

  protected iconName = 'help';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['icon']) {
      this.iconName = this.icon?.trim() || 'help';
    }
  }
}
